import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

const DEFAULT_WIDTH = 420;
export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderGray60,
      width: DEFAULT_WIDTH,
      zIndex: theme.zIndex.modal,
      overflowY: 'hidden',
      boxShadow: theme.shape.boxShadowExtraLarge,

      '&$manualSelected': {
        height: 'max-content',
      },

      '&$isInfinityMode': {
        width: DEFAULT_WIDTH,
      },
    },
    isInfinityMode: {},
    title: {
      padding: theme.spacing(1.5, 1, 1.5, 2),
    },
    titleWrapper: {
      borderBottom: '1px solid #E2E2E2',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: 48,
    },
    closeButton: {
      cursor: 'pointer',
      color: COLORS.gray.gray40,
      marginRight: theme.spacing(2),
      fontSize: theme.typography.pxToRem(16),
    },
    button: {
      height: 16,
      width: 16,
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    blockCustomFormula: {
      padding: theme.spacing(3),
    },
    error: {
      paddingBottom: theme.spacing(2),
    },
  }),
  { name: 'FormulaMenu' }
);
